import type { ContextFieldId } from '../../types/ids';

export type ContextGroupKey = 'angebot' | 'instagram' | 'arbeitsweise';

/** Gruppierung der neun Kontextfragen auf drei Routen (Abschnitt 11.1). */
export const CONTEXT_GROUPS: Record<ContextGroupKey, ContextFieldId[]> = {
  angebot: ['productType', 'priceRange', 'offerStage'],
  instagram: ['audienceType', 'instagramExperience', 'desiredInstagramRole'],
  arbeitsweise: ['visibilityModel', 'weeklyTimeBudget', 'personalSalesEffort'],
};

export const CONTEXT_GROUP_ORDER: ContextGroupKey[] = ['angebot', 'instagram', 'arbeitsweise'];

export const CONTEXT_GROUP_PATHS: Record<ContextGroupKey, string> = {
  angebot: '/kontext/angebot',
  instagram: '/kontext/instagram',
  arbeitsweise: '/kontext/arbeitsweise',
};

/** Liefert die erste Kontextgruppe, in der mindestens ein Feld noch unbeantwortet ist. */
export function firstIncompleteContextGroup(
  context: Partial<Record<ContextFieldId, string>>,
): ContextGroupKey | undefined {
  return CONTEXT_GROUP_ORDER.find((group) =>
    CONTEXT_GROUPS[group].some((field) => context[field] === undefined),
  );
}

export function isContextComplete(context: Partial<Record<ContextFieldId, string>>): boolean {
  return firstIncompleteContextGroup(context) === undefined;
}
